module.exports = __webpack_public_path__ + "static/img/3areaA_12.bf32b47.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/3areaA_12.png
// module id = 1024
// module chunks = 1